import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api的base_url
  timeout: 500000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['X-Token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }

  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
    * code为非200是抛错 可结合自己业务进行修改
    */
    const res = response.data
    if (res.code !== 200) {
      // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        MessageBox.confirm('登录已超时，可以【取消】继续留在该页面，或者【重新登录】', '超时提醒', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('FedLogOut').then(() => {
            location.reload()// 为了重新实例化vue-router对象 避免bug
          })
        })
      } else if (res.code === 401 || res.code === 403) {
        MessageBox.confirm('登录密码错误或无权限', '登录失败', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('FedLogOut').then(() => {
            location.reload()// 为了重新实例化vue-router对象 避免bug
          })
        })
      } else {
        Message({
          message: res.message || res.msg,
          type: 'error',
          duration: 5 * 1000
        })
      }
      return Promise.reject('error')
    } else {
      return response.data
    }
  },
  error => {
    console.log(error);
    if (error.response && error.response.status == 400) {  //调用远程服务时，前端类型和后端不匹配

      // var message = '<strong>'+error.response.data.detail +'</strong><br>'
      // //异常信息需要特殊处理一下
      // var errors = Object.entries(error.response.data.errors).map(([key, value]) => ({key,value}));
      // errors.forEach(item=>{
      //   message +=item.key +":"

      //   item.value.forEach(dtl =>{
      //     message +=" " +dtl;
      //   })

      //   message +="<br>";
      // })
      Message({
        dangerouslyUseHTMLString: true,
        message: `错误的请求，请重新登录后再试`,
        type: 'error',
        duration: 10 * 1000
      })
    } else if (error.response.status == 403) {
      Message({
        dangerouslyUseHTMLString: true,
        message: `无权限`,
        type: 'error',
        duration: 10 * 1000
      })
    } else {
      Message({
        message: '请先登录',
        type: 'error',
        duration: 5 * 1000
      })
    }
    return Promise.reject(error)
  }
)

export default service
